import { useEffect } from "react";
import List from "@/components/List";
import InformationRow from "@/components/Row/InformationRow";
import NoContentMessage from "@/components/NoContentMessage";
import { useInformationsQuery } from "@/hooks";
import { LIST_PAGE_LIMIT } from "@/lib/constants";

export default function InformationsList({ id }) {
  const { data, ...result } = useInformationsQuery({
    variables: { key: id, offset: 0, limit: LIST_PAGE_LIMIT },
  });
  const items = data?.informations;

  useEffect(() => {
    if (items && items?.data?.[0]) {
      const latest = items.data[0];
      window.localStorage.setItem("latestInformation", latest.id);
      window.localStorage.setItem("currentInformarion", latest.id);
    }
  }, [items]);

  return (
    <List
      {...result}
      header={{ text: "お知らせ一覧" }}
      items={items}
      limit={LIST_PAGE_LIMIT}
      itemComponent={InformationRow}
      noContent={<NoContentMessage message="お知らせはありません" />}
      viewTypeClassName=""
    />
  );
}
